import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export function Impressum() {
  return (
    <div className="min-h-screen bg-white text-ink-900">
      <header className="border-b border-border">
        <div className="container flex items-center justify-between py-4">
          <Link to="/" className="flex items-center gap-2">
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-xl bg-brand-gradient">
              <Heart className="h-4 w-4 text-white" fill="currentColor" />
            </span>
            <span className="text-lg font-bold tracking-tight">Parble</span>
          </Link>
          <Link to="/" className="text-sm font-semibold text-ink-500 hover:text-ink-900">
            Zurück zur Startseite
          </Link>
        </div>
      </header>

      <main className="container max-w-3xl py-12 prose prose-neutral">
        <div className="not-prose mb-10">
          <h1 className="text-4xl font-bold tracking-tight">Impressum</h1>
          <p className="mt-2 text-ink-500">
            Platzhalter — mit echten Firmen- und Kontaktdaten vor Launch zu
            ersetzen.
          </p>
        </div>

        <h2>Angaben gemäß § 5 DDG</h2>
        <p>
          [Firmenname oder Einzelunternehmer]<br />
          [Straße und Hausnummer]<br />
          [PLZ Ort]<br />
          Deutschland
        </p>

        <h2>Kontakt</h2>
        <p>
          Telefon: [eintragen]<br />
          E-Mail: hallo@parble.app
        </p>

        <h2>Umsatzsteuer-ID</h2>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
          [eintragen]
        </p>

        <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
        <p>
          [Name der verantwortlichen Person]<br />
          [Anschrift wie oben]
        </p>

        <h2>Streitbeilegung</h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung bereit:{" "}
          <a href="https://ec.europa.eu/consumers/odr">
            ec.europa.eu/consumers/odr
          </a>
          . Wir sind weder bereit noch verpflichtet, an einem
          Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
          teilzunehmen.
        </p>
      </main>
    </div>
  );
}
